
























































































































































import Vue, { VueConstructor } from 'vue';
import { CaseVm } from '../../viewModel';

export default (Vue as VueConstructor<Vue & {
  $refs: {},
}>).extend({
  name: 'CloseCasesTable',
  components: {
  },
  props: {
    caseData: {
      type: Array as () => CaseVm[],
      required: false,
      default: () => [] as CaseVm[],
    },
    gcs: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      expand: false as boolean,
      isMobile: false as boolean,
      title: 'Close Cases' as string,
      headers: [
        { text: 'Beschreibung', value: 'caseDescriptionShort' },
        { text: 'Geschlossen am', value: 'caseClosed' },
        { text: 'Produkt', value: 'caseGroup1' },
        { text: 'Status', value: 'caStDescription' },
        { text: 'Zuständig', value: 'staffSignature' },
        { text: 'Eröffnet am', value: 'createDate' },
        { text: 'Abrechnungskennzeichen', value: 'caseInvMarkDescription' },
      ],
      subHeaders: [
        { text: 'Mitarbeitername', value: 'staffSignature' },
        { text: 'Beschreibung', value: 'caTcDescription' },
        { text: 'Datum (Startzeit)', value: 'caTcStart' },
        { text: 'Uhrzeit (Startzeit)', value: 'hour' },
        { text: 'Endezeit', value: 'caTcEnd' },
        { text: 'Dauer', value: 'caTcHours' },
        { text: 'Freiminuten', value: 'caTcHoursFree' },
      ],
    };
  },
  created() {
    this.getAllCloseCases();
    if (this.gcs) {
      this.headers.unshift({ text: 'Vorgang-ID', value: 'caseId' });
      this.headers.pop();
    }
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    getAllCloseCases() {
      this.$emit('getAllCloseCases');
    },
    expandAttendanceCloseCase(props: any) {
      props.expanded = !props.expanded;
      this.$emit('expandAttendanceCloseCase', props);
    },
  },
});
